const initUgMenu = () => {
  const onePageLinks = document.querySelectorAll('.onepage-link > a ');
  if(onePageLinks.length<1) return;

  // Lese den Ankerlink aus der URL
  const hash = window.location.hash
  const menuLinks = document.querySelectorAll('nav .onepage-link > a');

  menuLinks.forEach((link) => {
    // Entferne das führende '/' vom href-Attribut des Links
    const href = link.getAttribute('href').substring(1);
    if (href === hash) {
      link.classList.add('showed');
    }
  });


  onePageLinks.forEach((link) => {
      link.addEventListener('click', function () {
        onePageLinks.forEach((ele)=>{
          ele.classList.remove("showed");
        })
        this.classList.add("showed")
      });
    })
};
export default initUgMenu;





